import React from "react";
import EditUserForm from "./components/EditUserForm";

const EditUserFormContainer=()=><EditUserForm/>;

export default EditUserFormContainer;